
import './App.css';
import Draw from './Draw';
import Menu from './Menu';

function App() {
  return (
    <>
    
    
    <Draw/>
    </>
  );
}

export default App;
